import { Field, reduxForm } from 'redux-form';
import { ImportPatientCCDA, newPatient, showPatientsSubMenus } from './actions/PatientActions';
import { Tab, Tabs } from 'material-ui/Tabs';
import Address from './address.js';
import Alert from 'react-s-alert';
import { connect } from 'react-redux';
import CustomFields from './custom_fields.js';
import FontIcon from 'material-ui/FontIcon';
import Insurance from './insurance.js';
import PatientGuardian from './components/guardian/patient_guardian';
import PatientInfo from './patient_info';
import PatientInfoForm from './account_details';
import PatientLocation from './patientLocation.js';
import React from 'react';
import { isValidFileType, renderUploadField } from '../../components/reduxFields';
import { base64Decode, showWarningMessage } from '../../actions/utilAction';
//import history from '../../history.js';

const stylesupload = {
  uploadButton: {
    verticalAlign: 'middle',
  },
  uploadInput: {
    cursor: 'pointer',
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    width: '100%',
    opacity: 0,
  },
  block: {
    maxWidth: 250,
  },
  checkbox: {
    marginBottom: 16,
  },

};
class TabsSimple extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      patientdata: null,
      patientId: this.props.match.params.id ? base64Decode(this.props.match.params.id) : 0,
      encryptedPatientId: props.match.params.id ? props.match.params.id : null,
      //isExpiredInsurance: parseInt(props.match.params.isExpiredInsurance, 10),      
      isExpiredInsurance: 0,      
      isPatientInfoExist: true,
      activeTab: 0,
      activeTabValue: '0',
    };

  }

  componentDidUpdate() { //  Reset Form fields (Update Reducer) when new User.
    if (this.props.match.params.id === undefined) {
      // console.log('New Client Api Call: ');
      // this.props.newPatient();
    }

  }

  componentDidMount() {
    const queryParams = new URLSearchParams(window.location.search);
    const tabValue = queryParams.get('tab');
    let defaultTabValue = tabValue ? tabValue: 0;

    if (!this.state.patientId) {
      this.props.newPatient();
    }
    
    this.handlePatientTabChange(defaultTabValue.toString() || '0');        
  }

  componentWillMount() {
    // console.log('this.props: ', this.props);
    if (this.props.match.params.id !== undefined) {
      this.setState({patientId : base64Decode(this.props.match.params.id)});
      // let masterData = {
      //   'masterdata': 'authorizedprocedure',
      // };
      // this.props.getPatientMasterData(masterData);
      // this.props.getPatientPreference(this.props.match.params.id);
      // this.props.getPatientAddressById(this.props.match.params.id);
      // this.props.getPatientPhoneById(this.props.match.params.id);
      // this.props.getPatientInsurance(this.props.match.params.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    
    // if (!base64Decode(nextProps.match.params.id) && this.state.patientId) {
      
    // }
    // // console.log(this.props.match.params.id);

    if (this.props.match.params.id !== nextProps.match.params.id) {
      if(nextProps.match.params.id) {
        this.props.showPatientsSubMenus(true);
        this.setState({ patientId: base64Decode(nextProps.match.params.id)});
        // this.props.getPatientDetailsById(nextProps.match.params.id);
      } else {
        this.setState({ patientId: null });
        this.props.newPatient();
        this.handlePatientTabChange('0');
      }
    }

    if (nextProps.saved_patient && this.props.saved_patient !== nextProps.saved_patient) {
      let patientdata = nextProps.saved_patient;
      this.setState({ patientdata: patientdata });
    }

    if (nextProps.get_patient_byid && this.props.get_patient_byid !== nextProps.get_patient_byid) {
      let patientdata = nextProps.get_patient_byid;
      this.setState({ patientdata: patientdata });
    }
  }
  handleOpen = () => {
    this.setState({ open: true });
  };
  handleClose = () => {
    this.setState({ open: false });
  };

  _handleFileChange(e) {
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];
      // console.log(file.type);
    if (file) {
          // console.log('Please select a valid image');
          // this.setState({ validImageError: 'only jpeg, jpg, gif, bmp, png image type allowed.' });
      let isValidTypeImage = isValidFileType(file.name, 'xml');
      if (!isValidTypeImage) {
        showWarningMessage('Please select a valid type CCDA');
      } else {
        Alert.closeAll();
        reader.onloadend = () => {
          this.setState({
            file: file,
            imagePreviewUrl: reader.result,

          });
          this.props.ImportPatientCCDA(reader.result);
        };
        reader.readAsDataURL(file);
      }
    }
  };

  setActive(tabValue) {
    this.setState({ activeTab: tabValue });
    Alert.closeAll();
  }

  handlePatientTabChange = (value) => { //  Change Tab on form Submit.    
   // history.push('/client/' + `${this.state.encryptedPatientId}`);

    this.setState({ activeTabValue: value, activeTab: value });
    // Alert.closeAll();
  };

  render() {
    var styles = {
      default_tab: {
        height: '50px',
        fontSize: '13px',
      },
      active_tab: {
        color: '#fff',
        backgroundColor: 'rgba(0, 0, 0, 0.10)',
        height: '48px',
        fontSize: '13px',
      },
    };
    styles.tab = [];
    styles.tab[0] = styles.default_tab;
    styles.tab[1] = styles.default_tab;
    styles.tab[2] = styles.default_tab;
    styles.tab[3] = styles.default_tab;
    styles.tab[4] = styles.default_tab;
    styles.tab[5] = styles.default_tab;
    styles.tab[6] = styles.default_tab;
    styles.tab[this.state.activeTab] = styles.active_tab;
    styles.tab[this.state.slideIndex] = Object.assign({}, styles.tab[this.state.slideIndex], styles.active_tab);
    return (
      <div>
        <h2 className="page_title">{!this.state.patientId ? 'Add Client' : 'Update Client'}</h2>
        <div className="importccd">
          {/* <FlatButton
            label="Import CCDA"
            className="imprbtn"
            labelPosition="before"
            style={stylesupload.uploadButton}
            containerElement="label"
            fullWidth={true}> */}
            <Field
              name="PhotoBase64"
              type="file"
              style={stylesupload.uploadInput}
              component= {renderUploadField}
              onChange={(e) => this._handleFileChange(e)}
              label="Client Photo" />
          {/* </FlatButton> */}
        </div>
        {this.state.patientId ?
          <PatientInfo patientId={this.state.patientId} /> : ''}
        <Tabs className="custom_tabs" value={this.state.activeTabValue} onChange={this.handlePatientTabChange}>
          <Tab
            onClick={(e) => this.setActive(0)}
            style={styles.tab[0]}
            value="0"
            className="customtab"
            icon={<FontIcon className="material-icons">local_library</FontIcon>}
            label={<font>Demographic Info</font>}>

                {
                  this.state.activeTabValue === '0' ?
                    <PatientInfoForm patientId={ this.state.patientId } location={this.props.location.pathname.split('/')} handlePatientTabChange={this.handlePatientTabChange} />
                    : ''
                }
            
          </Tab>
          <Tab
            onClick={(e) => this.setActive(1)}
            style={styles.tab[1]}
            value="1"
            disabled={!this.state.patientId}
            className="customtab"
            icon={<FontIcon className="material-icons">people</FontIcon>}
            label={<font>Guardian/Guarantor</font>}>
            <div className="readmin-panel">
              <div className="panel-body">
                {
                  this.state.activeTabValue === '1' ?
                    <PatientGuardian patient_id={ this.state.patientId } handlePatientTabChange={this.handlePatientTabChange} />
                    : ''
                }
              </div>
            </div>
          </Tab>
          <Tab
            onClick={(e) => this.setActive(2)}
            style={styles.tab[2]}
            value="2"
            disabled={!this.state.patientId}
            className="customtab"
            icon={<FontIcon className="material-icons">home</FontIcon>}
            label={<font>Address</font>}>
            <div className="readmin-panel">
              <div className="panel-body">
                {
                  this.state.activeTabValue === '2' ?
                    <Address patient_id={this.state.patientId} handlePatientTabChange={this.handlePatientTabChange} />
                    : ''
                }
              </div>
            </div>
          </Tab>
          {/* <Tab
              onClick={(e) => this.setActive(3)}
              style={styles.tab[3]}
              value="3"
              disabled={!this.props.get_patient_byid}
              className="customtab"
              icon={<FontIcon className="material-icons">content_paste</FontIcon>}
              label={<font>Authorization</font>}>
                <div className="readmin-panel">
                    <div className="panel-body">
                         <Authorization patientId={ this.state.patientId } handlePatientTabChange={this.handlePatientTabChange} />
                    </div>
                </div>
            </Tab>*/}
          <Tab
            onClick={(e) => this.setActive(4)}
            style={styles.tab[4]}
            value="4"
            className="customtab"
            disabled={!this.state.patientId}
            icon={<FontIcon className="material-icons">assignment</FontIcon>}
            label={<font>Insurance</font>}>
            <div className="readmin-panel">
              <div className="panel-body">
                {
                  this.state.activeTabValue === '4' ?
                    <Insurance patientId={ this.state.patientId } handlePatientTabChange={this.handlePatientTabChange} />
                    : ''
                }
              </div>
            </div>
          </Tab>
          <Tab
            onClick={(e) => this.setActive(5)}
            style={styles.tab[5]}
            value="5"
            className="customtab"
            disabled={!this.state.patientId}
            icon={<FontIcon className="material-icons">build</FontIcon>}
            label={<font>Custom Fields</font>}>
            <div className="readmin-panel">
              <div className="panel-body">
                {
                  this.state.activeTabValue === '5' ?
                    <CustomFields patientId={ this.state.patientId } handlePatientTabChange={this.handlePatientTabChange} />
                    : ''
                }
              </div>
            </div>
          </Tab>
          <Tab
            onClick={(e) => this.setActive(6)}
            style={styles.tab[6]}
            value="6"
            className="customtab"
            disabled={!this.state.patientId}
            icon={<FontIcon className="material-icons">today</FontIcon>}
            label={<font>Availability</font>}>
            <div className="readmin-panel">
              <div className="panel-body">
                {
                  this.state.activeTabValue === '6' ?
                  <PatientLocation patientId={ this.state.patientId }/>
                    : ''
                }

              </div>
            </div>
          </Tab>
        </Tabs>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    saved_patient: state.patient.saved_patient,
    get_patient_byid: state.patient.get_patient_byid,
    patientPreference: state.patient.patientPreference,
  };
};

// const mapDispatchToProps = (dispatch) => {
//   return {
//     getPatientDetailsById: (patientId) => dispatch(getPatientDetailsById(patientId)),
//     getPatientPreference: (patientId) => dispatch(getPatientPreference(patientId)),
//     getPatientAddressById: (patientId) => dispatch(getPatientAddressById(patientId)),
//     getPatientPhoneById: (patientId) => dispatch(getPatientPhoneById(patientId)),
//     getMasterData: () => dispatch(getMasterData()),
//     newPatient: () => dispatch(newPatient()),
//   };
// };

TabsSimple = reduxForm({
  form: 'PatientClientForm',
})(TabsSimple);
export default connect(mapStateToProps, { showPatientsSubMenus, newPatient, ImportPatientCCDA })(TabsSimple);



// WEBPACK FOOTER //
// ./src/modules/patients/index.js